module.exports = __webpack_public_path__ + "static/media/YM06_4.7eda2adb.jpg";